import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
  data: [],
  meta: {},
  extra: {},
  status: 'idle',
  errors: null,
  count: 0
}

export const fetchUserNotification = createAsyncThunk(
  'module/fetchUserNotification',
  async ({ accessToken, endpoint, spoofedUserId }) => {
    if (spoofedUserId) {
      let spoofQuery = `?spoofUserID=${spoofedUserId}`
      if (endpoint.includes('?')) {
        spoofQuery = spoofQuery.replace('?', '&')
      }
      endpoint += spoofQuery
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_DOMAIN}/${endpoint}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
    return response.data
  }
)

export const userNotificationSlice = createSlice({
  name: 'userNotification',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchUserNotification.pending, (state, action) => {
        state.status = 'loading'
      })
      .addCase(fetchUserNotification.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload.data
        state.meta = action.payload.meta
        state.extra = action.payload.extra
      })
      .addCase(fetchUserNotification.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
  },
})

export const selectUserNotification = (state) => state.userNotification
export default userNotificationSlice.reducer
